<template>
  <div class="flex w-full flex-col gap-4">
    <h2 class="mb-4 text-sm lg:text-3xl font-bold text-blue">
      Please wait while we redirect you to the website...
    </h2>
    <HorizontalSeparator class="mb-4"/>
    <span class="hidden md:block mb-4 text-2xl text-grey-70">
      If the redirect has not happened within a second or two click...
    </span>

    <a :href="website" target="_blank">
      <InputButton block style-type="contact-form">
        Visit Website
      </InputButton>
    </a>

    <div class="flex w-full flex-col gap-4 lg:w-3/12">
      <InputButton
          block
          style-type="contact-form-red"
          @click="$emit('closeClick')"
      >
        Close this window<br/>
        <span class="text-xs"> and return to the listing of agencies </span>
      </InputButton>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import InputButton from 'Components/InputButton';
import HorizontalSeparator from 'Components/HorizontalSeparator';
import AcCard from 'Components/AcCard';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'ContactWebsiteSuccess',
  components: {AcCard, HorizontalSeparator, InputButton},
  props: {
    agency: {
      type: Object,
    },
    userType: {
      type: String,
    },
  },
  data() {
    return {
      website: '',
      fetching: true,
      error: false,
    };
  },
  computed: {    
    ...mapState('contact', ['isSkipped']),
  },
  methods: {
    ...mapMutations('contact', ['setIsSkipped']),
  },
  mounted () {
    if (!this.isSkipped) {
        this.$emit('registerContact');
    }
    axios
        .get(`/api/agencyWebsite/${this.agency.AgencyTag}`, {
          params: {
            userType: this.userType,
          },
        })
        .then((response) => {
          this.website = response.data.data.website;
          if (!this.website.startsWith('http')) {
            this.website = `https://${this.website}`;
          }

          const redirectDelay = 1250;
          window.setTimeout(() => {
            window.open(this.website);
          }, redirectDelay);
        })
        .catch((error) => {
          this.error = true;
        })
        .finally(() => {
          this.fetching = false;
          this.setIsSkipped(false);
        });
  },
};
</script>
